<template>
  <div class="modal-overlay">
    <div class="modal-container">

      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Incluir Interação</h6>
        <i class="bi bi-x-circle close-icon" @click="cancel"></i>
      </div>

      <!-- Conteúdo do Modal -->
      <div class="modal-content">
        <div v-if="isLoading">
          <LoadingSpinner />
        </div>

        <h5 class="section-title">{{ form.classificacao }}</h5>

        <!-- Exibe Data e Turma quando a classificação for "Aula experimental - confirmar" ou "Aula experimental - confirmada" -->
        <div class="turma" v-if="form.classificacao === 'Aula experimental - confirmar' || form.classificacao === 'Aula experimental - confirmada' || form.classificacao === 'Aula experimental - realizada'">
          <p style="color: blue;">Data: {{ globalUtils.formatarData(ultimaDataAula) || globalUtils.formatarData(form.data_aula_experimental) }}</p>
          <p>Nível: {{ ultimaNivel || nivelNome }}</p>
          <p>{{ ultimaTurmaNome || turmaNome }}</p>
        </div>

        <!-- Linha 1: Classificação, Data da ação e Ação realizada -->
        <div class="row">
          <div class="col-6">
            <div class="form-group">
              <label>Ação realizada <span class="required">*</span></label>
              <select v-model="form.acao" class="form-control">
                <option value="">Selecione</option>
                <option v-for="opcao in acoesOptions" :key="opcao" :value="opcao">{{ opcao }}</option>
              </select>
            </div>
          </div>
        </div>

        <!-- Presente: Data próximo contato -->
        <div v-if="showProximoContatoPresente">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Data próximo contato <span class="required">*</span></label>
                <input type="date" v-model="form.data_proximo_contato" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <div v-if="showMotivoExtraConfirmar || showMotivoExtraConfirmada">
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <label>Motivo <span class="required">*</span></label>
                <input type="text" v-model="form.motivo" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <!-- Regra 2: Motivo e Data próximo contato -->
        <div v-if="showRegra2">
          <div class="row">
            <div class="col-8">
              <div class="form-group">
                <label>Motivo <span class="required">*</span></label>
                <input type="text" v-model="form.motivo" class="form-control" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Data próximo contato <span class="required">*</span></label>
                <input type="date" v-model="form.data_proximo_contato" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <!-- Regra 3: Campos para "Prospect - Agendar Aula Experimental" e ação "Aula Experimental Agendada" -->
        <div v-if="showRegra3">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Data da aula experimental <span class="required">*</span></label>
                <input type="date" v-model="form.data_aula_experimental" class="form-control" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Nível <span class="required">*</span></label>
                <select v-model="form.nivel_id" class="form-control">
                  <option value="">Selecione</option>
                  <option v-for="nivel in niveis" :key="nivel.id" :value="nivel.id">
                    {{ nivel.nivel }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Turma <span class="required">*</span></label>
                <select v-model="form.turma_id" class="form-control">
                  <option value="">Selecione</option>
                  <option
                    v-for="turma in turmas"
                    :key="`${turma.id}-${turma.dia_semana}-${turma.horario}`"
                    :value="`${turma.id}-${turma.dia_semana}-${turma.horario}`"
                  >
                    {{ `Turma: ${turma.id} | Dia: ${turma.dia_semana} | Hora: ${(turma.horario || '').slice(0,5)} | Instrutor: ${turma.instrutor}` }}
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Data próximo contato <span class="required">*</span></label>
                <input type="date" v-model="form.data_proximo_contato" class="form-control" />
              </div>
            </div>
          </div>
        </div>

        <!-- Regra 4: Campos para "Aula experimental - confirmar" e ação "Aula Experimental Reagendada" -->
        <div v-if="showRegra4">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Data da aula experimental <span class="required">*</span></label>
                <input type="date" v-model="form.data_aula_experimental" class="form-control" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Nível <span class="required">*</span></label>
                <select v-model="form.nivel_id" class="form-control">
                  <option value="">Selecione</option>
                  <option v-for="nivel in niveis" :key="nivel.id" :value="nivel.id">
                    {{ nivel.nivel }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label>Turma <span class="required">*</span></label>
                <select v-model="form.turma_id" class="form-control">
                  <option value="">Selecione</option>
                  <option
                    v-for="turma in turmas"
                    :key="`${turma.id}-${turma.dia_semana}-${turma.horario}`"
                    :value="`${turma.id}-${turma.dia_semana}-${turma.horario}`">
                    {{ `Turma: ${turma.id} | Dia: ${turma.dia_semana} | Hora: ${(turma.horario || '').slice(0,5)} | Instrutor: ${turma.instrutor}` }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label>Motivo <span class="required">*</span></label>
                <input type="text" v-model="form.motivo" class="form-control" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Data próximo contato <span class="required">*</span></label>
                <input type="date" v-model="form.data_proximo_contato" class="form-control" />
              </div>
            </div>
            <!-- Reagendamentos: campo somente leitura -->
            <!-- <div class="col-3">
              <div class="form-group">
                <label>Reagendamentos</label>
                <input type="number" :value="reagendamentos" class="form-control" disabled />
              </div>
            </div> -->
          </div>
        </div>

        <!-- Regra 5: Não inclui nenhum novo campo -->
        <div v-if="showRegra5">
        </div>

        <!-- Regra 6: Campo para "Aula Experimental - confirmar" e ação "Aula Experimental Confirmada" -->
        <div v-if="showRegra6">
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Data próximo contato <span class="required">*</span></label>
                <input type="date" v-model="form.data_proximo_contato" class="form-control" />
              </div>
            </div>
          </div>
        </div>
       
        <div
          v-if="form.classificacao === 'Prospect - Agendar Aula Experimental'
            && form.acao === 'Aula Experimental Agendada'
            && temCreditoAulaExperimental"
          class="alert alert-info"
          style="margin-top:10px;"
        >
          💳 O cliente já pagou esta Aula Experimental.
          Será utilizado o crédito do pagamento
          <strong>#{{ creditoAulaExperimental?.id }}</strong>
          (R$ {{ globalUtils.formatarValor(String(creditoAulaExperimental?.valor ?? '0')) }}).
          Nenhuma nova cobrança será gerada.
        </div>        

        <div v-if="showCobranca">
          <div v-if="contasMensagem" class="alert alert-warning" role="alert">{{ contasMensagem }}</div>
          <div class="row">

            <div class="col-3">
              <div class="form-group">
                <label>Valor unitário <span class="required">*</span></label>
                <input type="text" :value="globalUtils.formatarValor(form.valor_unitario)" class="form-control" disabled/>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Desconto (%)</label>
                <input type="number" v-model.number="form.desconto" class="form-control" min="0" max="100" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Total a pagar</label>
                <input type="text" :value="totalAPagar" class="form-control" disabled />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-3">
              <div class="form-group">
                <label>Forma de pagamento <span class="required">*</span></label>
                <select 
                  v-model="form.forma_pagamento_id" 
                  class="form-control"
                >
                  <option value="">Selecione</option>
                  <option v-for="forma in formasPagamento" :key="forma.id" :value="forma.id">
                    {{ forma.nome }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="isCheque(form.forma_pagamento_id)" class="col-2">
              <div class="form-group">
                <label>Banco <span class="required">*</span></label>
                <input type="text" v-model="form.banco" class="form-control" />
              </div>
            </div>
            <div v-if="isCheque(form.forma_pagamento_id)" class="col-2">
              <div class="form-group">
                <label>Agência <span class="required">*</span></label>
                <input type="text" v-model="form.agencia" class="form-control" />
              </div>
            </div>
            <div v-if="isCheque(form.forma_pagamento_id)" class="col-2">
              <div class="form-group">
                <label>Cheque nº <span class="required">*</span></label>
                <input type="text" v-model="form.cheque_numero" class="form-control" />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Vencimento <span class="required">*</span></label>
                <input 
                  type="date" 
                  v-model="form.vencimento" 
                  class="form-control" 
                  disabled
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>
                  Conta financeira
                  <span v-if="!isAInformar(form.forma_pagamento_id) && !!(form.data_pagamento && form.data_pagamento.trim())" class="required">*</span>
                </label>
                <select
                  v-model.number="form.conta_financeira_id"
                  class="form-control"
                  :disabled="isAInformar(form.forma_pagamento_id)"
                  :required="!isAInformar(form.forma_pagamento_id) && !!(form.data_pagamento && form.data_pagamento.trim())"
                >
                  <!-- A informar -->
                  <option v-if="isAInformar(form.forma_pagamento_id)" :value="null">
                    A informar
                  </option>

                  <!-- Normal (inclui Espécie) -->
                  <template v-else>
                    <option :value="null" disabled>Selecione</option>
                    <option v-for="conta in contasFinanceiras" :key="conta.id" :value="conta.id">
                      {{ conta.apelido }}
                    </option>
                  </template>
                </select>
              </div>
            </div>

            <!-- Autorização do cartão -->
            <div class="col-3" v-if="isCartao(form.forma_pagamento_id)">
              <div class="form-group">
                <label>Autorização <span class="required">*</span></label>
                <input
                  type="text"
                  v-model="form.numero_autorizacao"
                  class="form-control"
                  placeholder="Número da autorização"
                  :disabled="isAInformar(form.forma_pagamento_id)"
                />
              </div>
            </div>

            <div class="col-3">
              <div class="form-group">
                <label>Data pagamento <span class="required">*</span></label>
                <input
                  type="date"
                  v-model="form.data_pagamento"
                  class="form-control"
                  :disabled="isAInformar(form.forma_pagamento_id)"
                />
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Data recebimento</label>
                <input type="date" v-model="form.data_recebimento" class="form-control" disabled />
              </div>
           </div>

          </div>
        </div>
      </div>

      <!-- Rodapé (Ações) -->
       <div class="d-flex justify-content-end mt-4 mb-4">
         <button 
           class="btn btn-secondary me-2" 
           @click="cancel" 
           :disabled="isSubmitting"
         >
           Cancelar
         </button>
         <button
           :class="['btn', isSubmitting ? 'btn-success' : 'btn-primary']"
           :disabled="!formValid || isSubmitting"
           @click="salvarInteracao"
         >
           {{ isSubmitting ? 'Salvando…' : 'Salvar' }}
         </button>
       </div>
    </div>
  </div>
</template>

<script>
import { turmaDisponivel, mensagemTurmaIndisponivel } from '@/utils/turmasSelecao';
import { reactive, ref, computed, onMounted, watch, getCurrentInstance } from 'vue';
import axios from '@/services/axios';
import { loadOperationalAccounts, accountSelectionError, emptyAccountsMessage } from '@/services/operationalAccounts';
import globalUtils from '@/utils/globalUtils.js';

export default {
  name: 'IncluirInteracao',

  props: {
    id: { type: [String, Number], required: true },
    usuario: { type: String, required: true },
    ultimaClassificacao: { type: String, required: true },
    ultimaAcao: { type: String, required: true },
    ultimaDataAula: { type: String, default: '' },
    ultimaTurmaNome: { type: String, default: '' },
    ultimaNivel: { type: String, default: '' },
    nome_aluno: { type: String, required: true },
  },


  emits: ['fechar', 'salvou'],
  setup(props, { emit }) {

    const { proxy } = getCurrentInstance();
    const ultimaClassificacao = computed(() => props.ultimaClassificacao);
    const ultimaAcao = computed(() => props.ultimaAcao);
    const isLoading = ref(true);
    const isSubmitting = ref(false);

    const today = () => new Date().toISOString().split('T')[0];

    // Formulário reativo
    const form = reactive({
      classificacao: '',
      data_acao: new Date().toISOString().split('T')[0], // Formato YYYY-MM-DD
      acao: '',
      motivo: '',
      data_proximo_contato: '',
      data_aula_experimental: '',
      nivel_id: '',
      turma_id: '',
      valor_unitario: '',
      desconto: 0,
      forma_pagamento_id: '',
      banco: '',
      agencia: '',
      cheque_numero: '',
      vencimento: props.id ? '' : today(),           // ← aqui
      conta_financeira_id: '',
      data_pagamento: '',
      data_recebimento: '',
      numero_autorizacao: null,
    });

    // Listas para os selects
    const niveis = ref([]);
    const turmas = ref([]);
    const formasPagamento = ref([]);
    const contasFinanceiras = ref([]);
    const contasMensagem = ref('');

    // ✅ Crédito Aula Experimental
    const temCreditoAulaExperimental = ref(false);
    const creditoAulaExperimental = ref(null);

    const carregarCreditoAulaExperimental = async () => {
      try {
        const { data } = await axios.get(`/operacional/prospeccao/${props.id}/credito-aula-experimental`);
        temCreditoAulaExperimental.value = !!data?.temCredito;
        creditoAulaExperimental.value = data?.credito ?? null;
      } catch (e) {
        console.warn('[credito] Falha ao consultar crédito aula experimental:', e);
        temCreditoAulaExperimental.value = false;
        creditoAulaExperimental.value = null;
      }
    };

    // Variável para reagendamentos
    const reagendamentos = ref(0);

    // Opções de Ação realizadas
    const acoesOptions = ref([]);

    const normTxt = (s) => (s ?? '')
      .toString()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim().toLowerCase();

    const contaPadraoGlobalId = computed(() => {
      const c = (contasFinanceiras.value || []).find(x => x.conta_padrao === true || x.conta_padrao === 1);
      return c?.id ? Number(c.id) : null;
    });

    const getFormaById = (id) => formasPagamento.value.find(f => Number(f.id) === Number(id));

    const isCartao = (formaId) => normTxt(getFormaById(formaId)?.nome).includes('cartao');

    const aplicarContaPadraoSeVazio = (formaId) => {
      const forma = getFormaById(formaId);
      if (!forma) return;

      const nome = normTxt(forma.nome);
      if (nome === 'especie' || nome === 'a informar' || nome === 'informar') return;

      if (form.conta_financeira_id !== null && form.conta_financeira_id !== '' && form.conta_financeira_id !== undefined) return;

      const porForma = forma.conta_financeira_padrao_id ? Number(forma.conta_financeira_padrao_id) : null;
      if (porForma) {
        form.conta_financeira_id = porForma;
        return;
      }

      const fallback = contaPadraoGlobalId.value;
      if (fallback) form.conta_financeira_id = fallback;
    };

    const definirClassificacaoPadrao = () => {
      const uc = ultimaClassificacao.value.toLowerCase();
      const ua = ultimaAcao.value.toLowerCase();

      // Caso “Prospect” recebendo “Agendar aula experimental” ou outras ações que levam a agendar
      if (
        uc === 'prospect' &&
        (
          ua === 'agendar aula experimental' ||
          ua === 'contato reagendado'       ||
          ua === 'agendar próximo contato'  ||
          ua === 'finalizado'               ||
          ua === 'matrícula'
        )
      ) {
        form.classificacao = 'Prospect - Agendar Aula Experimental';

      } else if (
        (uc === 'prospect - agendar aula experimental' || uc === 'aula experimental - realizada') &&
        ua === 'aula experimental agendada'
      ) {
        form.classificacao = 'Aula experimental - confirmar';

      } else if (
        uc === 'prospect - agendar aula experimental' &&
        ua === 'contato reagendado'
      ) {
        form.classificacao = 'Prospect - Agendar Aula Experimental';

      } else if (
        (uc === 'aula experimental - confirmar' || uc === 'aula experimental - confirmada') &&
        (ua === 'aula experimental cancelada' || ua === 'ausente')
      ) {
        form.classificacao = 'Prospect - Agendar Aula Experimental';

      } else if (
        uc === 'aula experimental - confirmar' &&
        ua === 'aula experimental confirmada'
      ) {
        form.classificacao = 'Aula experimental - confirmada';

      } else if (
        (uc === 'aula experimental - confirmar' || uc === 'aula experimental - confirmada') &&
        ua === 'aula experimental reagendada'
      ) {
        form.classificacao = 'Aula experimental - confirmar';

      } else if (
        uc === 'aula experimental - confirmar' &&
        ua === 'contato reagendado'
      ) {
        form.classificacao = 'Aula experimental - confirmar';

      } else if (
        uc === 'aula experimental - confirmada' &&
        ua === 'contato reagendado'
      ) {
        form.classificacao = 'Aula experimental - confirmada';

      } else if (
        uc === 'aula experimental - confirmada' &&
        ua === 'presente'
      ) {
        form.classificacao = 'Aula experimental - realizada';

      } else if (
        uc === 'aula experimental - realizada' &&
        ua === 'contato reagendado'
      ) {
        form.classificacao = 'Aula experimental - realizada';

      } else if (
        // uc === 'aula experimental - realizada' &&
        ua === 'finalizado'
      ) {
        form.classificacao = 'Prospect - Agendar Aula Experimental';
      }
    };


    // Atualiza as opções de Ação realizada com base na classificação
    const atualizarAcoes = () => {
      form.acao = '';
      const classificacao = form.classificacao;
      if (classificacao === 'Prospect') {
        acoesOptions.value = ['Contato Reagendado', 'Finalizado', 'Matrícula', 'Prospect'];
      } else if (classificacao === 'Prospect - Agendar Aula Experimental') {
        acoesOptions.value = ['Aula Experimental Agendada', 'Contato Reagendado', 'Finalizado', 'Matrícula'];
      } else if (classificacao === 'Aula experimental - confirmar') {
        acoesOptions.value = ['Aula Experimental Cancelada', 'Aula Experimental Confirmada', 'Aula Experimental Reagendada', 'Contato Reagendado', 'Finalizado', 'Matrícula'];
      } else if (classificacao === 'Aula experimental - confirmada') {
        acoesOptions.value = ['Aula Experimental Reagendada', 'Aula Experimental Cancelada', 'Contato Reagendado', 'Finalizado', 'Matrícula', 'Ausente', 'Presente'];
      } else if (classificacao === 'Aula experimental - realizada') {
        acoesOptions.value = ['Aula Experimental Agendada', 'Contato Reagendado', 'Finalizado', 'Matrícula'];
      } else {
        acoesOptions.value = [];
      }
    };

    // Computados para exibição condicional

    const showProximoContatoPresente = computed(() => {
      const c = (form.classificacao || '').trim();
      const a = (form.acao || '').trim();
      return c === 'Aula experimental - confirmada' && a === 'Presente';
    });

    const showRegra2 = computed(() => {
      const c = form.classificacao;
      const a = form.acao;
      if (c === 'Prospect' && ['Prospect', 'Contato Reagendado'].includes(a)) return true;
      if (c === 'Prospect - Agendar Aula Experimental' && ['Contato Reagendado'].includes(a)) return true;
      if (c === 'Aula experimental - confirmar' && ['Contato Reagendado', 'Aula Experimental Cancelada'].includes(a)) return true;
      if (c === 'Aula experimental - confirmada' && ['Contato Reagendado', 'Aula Experimental Cancelada'].includes(a)) return true;
      if (c === 'Aula experimental - realizada' && ['Contato Reagendado'].includes(a)) return true;
      return false;
    });

    const showRegra3 = computed(() => {
      const c = form.classificacao;
      const a = form.acao;
      if (c === 'Prospect - Agendar Aula Experimental' && ['Aula Experimental Agendada'].includes(a)) return true;
      if (c === 'Aula experimental - realizada' && ['Aula Experimental Agendada'].includes(a)) return true;
      return false;
    });

    const showRegra4 = computed(() => {
      const c = form.classificacao;
      const a = form.acao;
      if (c === 'Aula experimental - confirmar' && ['Aula Experimental Reagendada'].includes(a)) return true;
      if (c === 'Aula experimental - confirmada' && ['Aula Experimental Reagendada'].includes(a)) return true;
      return false;
    });

    const showRegra5 = computed(() => {
      const c = form.classificacao;
      const a = form.acao;
      if (c === 'Prospect' && ['Matrícula'].includes(a)) return true;
      if (c === 'Prospect - Agendar Aula Experimental' && ['Matrícula'].includes(a)) return true;
      if (c === 'Aula experimental - confirmar' && ['Matrícula'].includes(a)) return true;
      if (c === 'Aula experimental - confirmada' && ['Matrícula'].includes(a)) return true;
      if (c === 'Aula experimental - realizada' && ['Matrícula'].includes(a)) return true;
      return false;
    });

    const showRegra6 = computed(() => {
      return form.classificacao === 'Aula experimental - confirmar' && form.acao === 'Aula Experimental Confirmada';
    });


    const totalAPagar = computed(() => {
      const valor = parseFloat(form.valor_unitario.replace(/[^\d,.-]/g, '').replace(',', '.')) || 0;
      const desconto = parseFloat(form.desconto) || 0;
      const total = valor - (valor * desconto / 100);
      return total.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    });

    const isAInformar = (formaId) => {
      const forma = formasPagamento.value.find(f => f.id === formaId);
      return forma?.nome.toLowerCase().includes('informar');
    };

    // retorna true se a forma tiver nome "Espécie"
    const isEspecie = (formaId) => {
      const forma = formasPagamento.value.find(f => f.id === formaId);
      return forma?.nome.toLowerCase() === 'espécie';
    };

    const anexarMsgSistemaNoMotivo = (msg) => {
      const prefix = `[SISTEMA] ${msg}`;
      if (!form.motivo || !String(form.motivo).trim()) {
        form.motivo = prefix;
        return;
      }
      // evita duplicar
      if (String(form.motivo).includes(prefix)) return;
      form.motivo = `${prefix} | ${form.motivo}`;
    };

    // limpa e desabilita campos sempre que a forma mudar
    watch(
      () => form.forma_pagamento_id,
      (novaForma) => {
        // sempre zera conta e autorização quando troca forma
        form.conta_financeira_id = null;
        form.numero_autorizacao = null;

        // A informar: zera datas
        if (isAInformar(novaForma)) {
          form.data_pagamento   = null;
          form.data_recebimento = null;
          return;
        }

        // Espécie: não usa conta nem autorização
        if (isEspecie(novaForma)) {
          form.data_pagamento = form.vencimento || '';
          form.data_recebimento = form.data_pagamento
            ? (globalUtils.calcularDataRecebimento(
                form.data_pagamento,
                novaForma,
                formasPagamento.value
              ) || '')
            : '';
          return;
        }

        // demais: data_pagamento = vencimento
        form.data_pagamento = form.vencimento || '';

        // recebimento calculado
        form.data_recebimento = form.data_pagamento
          ? (globalUtils.calcularDataRecebimento(
              form.data_pagamento,
              novaForma,
              formasPagamento.value
            ) || '')
          : '';

        // ✅ aplica conta padrão (forma -> fallback global)
        aplicarContaPadraoSeVazio(novaForma);
      },
      { immediate: true }
    );

    // recalcula RECEBIMENTO sempre que DATA PAGAMENTO mudar (desde que não seja "A informar")
    watch(
      () => form.data_pagamento,
      (novaData) => {
        if (!form.forma_pagamento_id || isAInformar(form.forma_pagamento_id)) {
          form.data_recebimento = '';
          return;
        }
        form.data_recebimento = novaData
          ? (globalUtils.calcularDataRecebimento(
              novaData,
              form.forma_pagamento_id,
              formasPagamento.value
            ) || '')
          : '';
      }
    );

    const formValid = computed(() => {
      if (!form.classificacao || !form.data_acao || !form.acao) return false;
      if (showRegra2.value) {
        if (!form.motivo || !form.data_proximo_contato) return false;
      }
      if (showRegra3.value) {
        if (
          !form.data_aula_experimental ||
          !form.nivel_id ||
          !form.turma_id ||
          !form.data_proximo_contato // ||
          // !form.valor_unitario ||
          // form.desconto === '' ||
          // !form.forma_pagamento_id ||
          // !form.vencimento ||
          // !form.conta_financeira_id ||
          // !form.data_pagamento
        ) {
          return false;
        }
        // if (isCheque(form.forma_pagamento_id) && (!form.banco || !form.agencia || !form.cheque_numero)) return false;
      }
      if (showRegra4.value) {
        if (!form.data_aula_experimental || !form.nivel_id || !form.turma_id || !form.motivo || !form.data_proximo_contato)
          return false;
                // Cartão exige autorização
        if (isCartao(form.forma_pagamento_id)) {
          if (!(form.numero_autorizacao || '').trim()) return false;
        }
      }

      if (showProximoContatoPresente.value) {
        if (!form.data_proximo_contato) return false;
      }

      if (showCobranca.value) {
        // Data próximo contato é obrigatória
        if (!form.data_proximo_contato) return false;

        // campos financeiros obrigatórios
        if (!form.valor_unitario || form.desconto === '' || !form.forma_pagamento_id || !form.vencimento) {
          return false;
        }

        // Cartão exige autorização
        if (isCartao(form.forma_pagamento_id)) {
          if (!(form.numero_autorizacao || '').trim()) return false;
        }

        // “A informar” → não exige pagamento nem conta
        if (isAInformar(form.forma_pagamento_id)) {
          return true;
        }

        // Conta financeira: só se houver data_pagamento (inclui Espécie)
        if ((form.data_pagamento || '').trim() && !form.conta_financeira_id) {
          return false;
        }

        // Cheque: se informou pagamento, exige dados do cheque
        if (
          isCheque(form.forma_pagamento_id) &&
          (form.data_pagamento || '').trim() &&
          (!form.banco || !form.agencia || !form.cheque_numero)
        ) {
          return false;
        }
      }

      if (showRegra6.value) {
        if (!form.data_proximo_contato)
          return false;
      }

      if ((showMotivoExtraConfirmar.value || showMotivoExtraConfirmada.value) && !form.motivo) {
        return false;
      }
      return true;
    });

    const isCheque = (formaId) => {
      const forma = formasPagamento.value.find(fp => fp.id === formaId);
      return forma ? forma.nome.toLowerCase() === 'cheque' : false;
    };

    const carregarNiveis = async () => {
      try {
        const { data } = await axios.get('/cadastros/niveis-turmas', {
          params: { page: 1, limit: 10000 }
        });

        const lista = data?.data ?? data ?? [];
        const somenteAtivos = Array.isArray(lista)
          ? lista.filter(n => n.ativo !== false) // mantém se ativo=true ou undefined
          : [];

        // Ordenar por nome/nível (ajuste a chave se necessário)
        // somenteAtivos.sort((a, b) =>
        //   String(a.nivel ?? a.nome ?? '')
        //     .localeCompare(String(b.nivel ?? b.nome ?? ''), 'pt-BR', {
        //       sensitivity: 'base',
        //       numeric: true
        //     })
        // );

        niveis.value = somenteAtivos;
      } catch (error) {
        console.error('Erro ao carregar níveis:', error);
        niveis.value = [];
      }
    };

    const idxDia = (d) => {
      let s = String(d || '')
        .normalize('NFD').replace(/\p{Diacritic}/gu, '')
        .toLowerCase().replace(/-?feira/g, '').trim();
      s = s.split(/\s+/)[0].slice(0,3); // seg, ter, qua, qui, sex, sab, dom
      return { seg:1, ter:2, qua:3, qui:4, sex:5, sab:6, dom:7 }[s] ?? 99;
    };

    const toMin = (h) => {
      const m = String(h || '').match(/^(\d{1,2}):(\d{2})(?::\d{2})?/);
      if (!m) return Number.MAX_SAFE_INTEGER;
      return (+m[1]) * 60 + (+m[2]);
    };

    let versaoTurmas = 0;
    const carregarTurmas = async () => {
      const versao = ++versaoTurmas;
      turmas.value = [];
      if (!form.nivel_id) {
        turmas.value = [];
        return;
      }

      try {
        // busca só o dias-horários (já vem com nivel_nome e instrutor_nome)
        const resDias = await axios.get('/cadastros/dias-horarios-turmas', { params: { ativo: true } });
        if (versao !== versaoTurmas) return;
        const diasData = resDias.data.data || resDias.data || [];

        // pega o nome do nível selecionado
        const sel = niveis.value.find(n => String(n.id) === String(form.nivel_id));
        const nomeNivel = sel?.nivel;

        turmas.value = diasData
          // filtra apenas as turmas do nível
          .filter(d => nomeNivel ? d.nivel_nome === nomeNivel : true)
          // mapeia usando instrutor_nome direto do registro
          .map(d => ({
            id:         d.turma_id,
            dia_semana: d.dia_semana,
            horario:    d.horario,
            instrutor:  d.instrutor_nome || 'Não informado'
          }))
          // ordena por dia e horário
          .sort((a, b) =>
            (Number(a.id) - Number(b.id)) ||                 // 1) ID da turma
            (idxDia(a.dia_semana) - idxDia(b.dia_semana)) || // 2) Dia (seg→dom)
            (toMin(a.horario) - toMin(b.horario))            // 3) Horário (crescente)
          );

      } catch (err) {
        console.error('❌ Erro ao carregar turmas:', err);
        turmas.value = [];
      }
    };

    const carregarFormasPagamento = async () => {
      try {
        const { data } = await axios.get('/cadastros/formas-pagamento');

        const norm = s => (s ?? '')
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .trim().toLowerCase();

        const lista = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : []);

        const ordemPersonalizada = {
          'pix': 1,
          'especie': 2,
          'cartao de credito a vista': 3,
          'cartao de credito parcelado': 4,
          'cartao de debito': 5,
          'boleto': 6,
          'transferencia bancaria': 7,
          'cheque': 8,
          'a informar': 9,
        };

        formasPagamento.value = lista
          .filter(fp => norm(fp.nome) !== 'brinde')
          .sort((a, b) => {
            const oa = ordemPersonalizada[norm(a.nome)] ?? 999;
            const ob = ordemPersonalizada[norm(b.nome)] ?? 999;
            if (oa !== ob) return oa - ob;
            return a.nome.localeCompare(b.nome, 'pt-BR');
          });

      } catch (error) {
        console.error("Erro ao carregar formas de pagamento:", error);
      }
    };

    const carregarContasFinanceiras = async () => {
      contasFinanceiras.value = [];
      contasMensagem.value = '';
      try {
        contasFinanceiras.value = await loadOperationalAccounts('aula_experimental_recebimento');
        if (!contasFinanceiras.value.length) contasMensagem.value = emptyAccountsMessage;
      } catch (error) {
        contasMensagem.value = accountSelectionError(error);
      }
    };

    const buscarValorAulaExperimental = async () => {
      try {
        const responseTipoValores = await axios.get('/financeiro/tipos-valores');
        const tipoValores = responseTipoValores.data.data || responseTipoValores.data;
        if (!Array.isArray(tipoValores)) return;
        const tipoAula = tipoValores.find(t => t.nome.trim() === 'Aula Experimental');
        if (tipoAula && tipoAula.id) {
          const responseValores = await axios.get('/financeiro/valores', {
            params: { tipo_valor: tipoAula.id }
          });
          const valores = responseValores.data.data || responseValores.data;
          if (Array.isArray(valores) && valores.length > 0) {
            const valoresFiltrados = valores.filter(v => String(v.tipo_id) === String(tipoAula.id));
            if (valoresFiltrados.length > 0) {
              valoresFiltrados.sort((a, b) => new Date(a.data) - new Date(b.data));
              form.valor_unitario = valoresFiltrados[0].valor.toString();
            }
          }
        }
      } catch (error) {
        console.error("Erro ao buscar valor da aula experimental:", error);
      }
    };

    const showMotivoExtraConfirmar = computed(() => {
      return (
        (form.classificacao.trim() === 'Aula experimental - confirmar' && form.acao.trim() === 'Finalizado') ||
        (form.classificacao.trim() === 'Prospect' && form.acao.trim() === 'Finalizado') ||
        (form.classificacao.trim() === 'Prospect - Agendar Aula Experimental' && form.acao.trim() === 'Finalizado') ||
        (form.classificacao.trim() === 'Aula experimental - realizada' && form.acao.trim() === 'Finalizado')
    );
    });

    const showMotivoExtraConfirmada = computed(() => {
      const classVal = form.classificacao.trim();
      const acaoVal = form.acao.trim();
      return classVal === 'Aula experimental - confirmada' &&
            (acaoVal === 'Finalizado' || acaoVal === 'Ausente');
    });

    const showCobranca = computed(() => {
      const c = (form.classificacao || '').trim();
      const a = (form.acao || '').trim();

      const base =
        c === 'Prospect - Agendar Aula Experimental' &&
        a === 'Aula Experimental Agendada';

      // ✅ Só mostra cobrança se NÃO houver crédito disponível
      return base && !temCreditoAulaExperimental.value;
    });

    watch(
      () => form.vencimento,
      novaData => {
          form.data_pagamento = novaData || '';
      },
      { immediate: true }
    );


    watch(() => form.nivel_id, async () => {
      form.turma_id = '';
      await carregarTurmas();
    });

    watch(() => [form.classificacao, form.acao], ([novaClassificacao, novaAcao]) => {
      if (novaClassificacao === 'Aula experimental - confirmada' && novaAcao === 'Presente') {
        buscarValorAulaExperimental();
      }
    });


    watch(
      () => [form.classificacao, form.acao],
      async ([c, a]) => {
        const base =
          (c || '').trim() === 'Prospect - Agendar Aula Experimental' &&
          (a || '').trim() === 'Aula Experimental Agendada';

        if (!base) {
          temCreditoAulaExperimental.value = false;
          creditoAulaExperimental.value = null;
          return;
        }

        // ✅ 1) primeiro verifica crédito
        await carregarCreditoAulaExperimental();

        // ✅ 2) só busca valor unitário se NÃO tiver crédito (pois aí vai cobrar)
        if (!temCreditoAulaExperimental.value) {
          await buscarValorAulaExperimental();
        } else {
          // opcional: limpar campos financeiros para não confundir
          form.forma_pagamento_id = '';
          form.conta_financeira_id = '';
          form.numero_autorizacao = null;
          // mantém vencimento/data_pagamento se quiser, mas pode limpar também
        }
      }
    );

    watch(() => form.classificacao, () => {
      form.acao = '';
      form.motivo = '';
      form.data_proximo_contato = '';
      form.data_aula_experimental = '';
      form.nivel_id = '';
      form.turma_id = '';
      form.valor_unitario = '';
      form.desconto = 0;
      form.forma_pagamento_id = '';
      form.banco = '';
      form.agencia = '';
      form.cheque_numero = '';
      form.vencimento = today();
      form.conta_financeira_id = '';
      form.data_pagamento = '';
    });

    const sanitizeDate = (dateStr) => {
      return dateStr && dateStr.trim() !== '' ? dateStr : null;
    };

    const turmaNome = computed(() => {
      const turmaSelecionada = turmas.value.find(turma => {
        return `${turma.id}-${turma.dia_semana}-${turma.horario}` === form.turma_id;
      });
      return turmaSelecionada
        ? `Turma: ${turmaSelecionada.id} | Dia: ${turmaSelecionada.dia_semana} | Hora: ${turmaSelecionada.horario} | Instrutor: ${turmaSelecionada.instrutor}`
        : '';
    });

    const salvarInteracao = async () => {
      if (isSubmitting.value) return;
      if (['Aula Experimental Agendada', 'Aula Experimental Reagendada'].includes(form.acao) && !turmaDisponivel(form.turma_id, turmas.value)) { alert(mensagemTurmaIndisponivel); return; }
      isSubmitting.value = true;

      try {
        // 0) Preparação de dados comuns
        const turmaSelecionada = turmas.value.find(
          (t) => `${t.id}-${t.dia_semana}-${t.horario}` === form.turma_id
        );

        const turmaStr = turmaSelecionada
          ? `Turma: ${turmaSelecionada.id} | Dia: ${turmaSelecionada.dia_semana} | Hora: ${turmaSelecionada.horario} | Instrutor: ${turmaSelecionada.instrutor}`
          : (props.ultimaTurmaNome || '');

        const nivelSelecionado = niveis.value.find((n) => String(n.id) === String(form.nivel_id));
        const nivelStr = nivelSelecionado ? nivelSelecionado.nivel : (props.ultimaNivel || '');

        const dataAulaFallback = form.data_aula_experimental || props.ultimaDataAula || '';

        // aplica fallback somente no que é seguro (datas)
        if (['Aula experimental - confirmar', 'Aula experimental - confirmada', 'Aula experimental - realizada'].includes(form.classificacao)) {
          form.data_aula_experimental = form.data_aula_experimental || dataAulaFallback;
          // ✅ NÃO sobrescreve nivel_id com string
        }

        // parse turmaId
        let turmaId = null;
        if (typeof form.turma_id === 'string' && form.turma_id.includes('-')) {
          turmaId = parseInt(form.turma_id.split('-')[0], 10);
        } else if (form.turma_id) {
          turmaId = parseInt(form.turma_id, 10);
        }

        const payloadBase = {
          ...form,
          turma_id: turmaId,
          nivel_nome: nivelStr,
          turma_nome: turmaStr,
          prospeccao_id: props.id,
          usuario: proxy.$globalState.userName,
          data_acao: sanitizeDate(form.data_acao),
          data_proximo_contato: sanitizeDate(form.data_proximo_contato),
          data_aula_experimental: sanitizeDate(form.data_aula_experimental),
          data_pagamento: sanitizeDate(form.data_pagamento),
          data_recebimento: sanitizeDate(form.data_recebimento) || null,
          vencimento: sanitizeDate(form.vencimento),
        };

        // ==========================================================
        // Grava o agendamento antes dos demais efeitos; a API valida e substitui em transação.
        // ==========================================================
        if (['Aula Experimental Agendada', 'Aula Experimental Reagendada'].includes(form.acao)) {
          await axios.post(
            `/operacional/aulas-experimentais-agendadas`,
            {
              substituir: true,
              prospeccao_id: props.id,
              nome_aluno: props.nome_aluno,
              data_aula: sanitizeDate(form.data_aula_experimental),
              nivel_id: form.nivel_id,
              turma_id: turmaSelecionada?.id ?? turmaId,
              horario: turmaSelecionada?.horario ?? null,
              dia_semana: turmaSelecionada?.dia_semana ?? null,
              turma_completa: turmaStr,
              status: form.acao.includes('Reagendada') ? 'Reagendada' : 'Agendada',
            }
          );
        }

        // ==========================================================
        // Confirma o vínculo já agendado antes dos demais efeitos.
        // ==========================================================
        if (form.acao === 'Aula Experimental Confirmada') {
          const parts = (props.ultimaTurmaNome || '').split('|');

          const turmaIdConfirm = parseInt(
            (parts[0] || '').replace('Turma:', '').trim(),
            10
          );

          const diaSemanaConfirm = (parts[1] || '').replace('Dia:', '').trim();
          const horarioConfirm   = (parts[2] || '').replace('Hora:', '').trim();

          const nivelIdConfirm = niveis.value.find((n) => String(n.id) === String(form.nivel_id) || n.nivel === props.ultimaNivel)?.id;

          const payloadConfirm = {
            prospeccao_id: props.id,
            nome_aluno: props.nome_aluno,
            data_confirmacao: sanitizeDate(form.data_acao),
            data_aula: sanitizeDate(form.data_aula_experimental),
            nivel_id: nivelIdConfirm,
            turma_id: turmaIdConfirm,
            horario: horarioConfirm,
            dia_semana: diaSemanaConfirm,
            turma_completa: turmaStr,
          };

          await axios.post(`/operacional/aulas-experimentais`, payloadConfirm);

          await axios.delete(
            `/operacional/aulas-experimentais-agendadas/prospeccao/${props.id}`
          );
        }

        // ==========================================================
        // 1) CRÉDITO/PAGAMENTO (ANTES DO HISTÓRICO para registrar msg)
        // ==========================================================

        // 1.1) Cenário de cobrança: Agendada
        if (showCobranca.value && parseFloat(form.valor_unitario || '0') > 0) {
          let cred = null;
          try {
            const { data } = await axios.get(
              `/operacional/prospeccao/${props.id}/credito-aula-experimental`
            );
            cred = data;
          } catch (e) {
            console.warn('[salvarInteracao] Falha ao consultar crédito aula experimental:', e);
          }

          if (cred?.temCredito && cred?.credito?.id) {
            anexarMsgSistemaNoMotivo(
              `Cliente possui crédito de Aula Experimental disponível (pagamento #${cred.credito.id}). Agendamento sem nova cobrança.`
            );
          } else {
            // cria pagamento (backend idempotente)
            const resp = await axios.post(
              `/operacional/prospeccao/${props.id}/pagamentos`,
              payloadBase
            );

            if (resp?.data?.reutilizado && resp?.data?.pagamento?.id) {
              anexarMsgSistemaNoMotivo(
                `Crédito de Aula Experimental já existia e foi reutilizado (pagamento #${resp.data.pagamento.id}).`
              );
            } else if (resp?.data?.pagamento?.id) {
              anexarMsgSistemaNoMotivo(
                `Crédito de Aula Experimental gerado (pagamento #${resp.data.pagamento.id}).`
              );
            } else if (resp?.data?.id) {
              anexarMsgSistemaNoMotivo(
                `Crédito de Aula Experimental gerado (pagamento #${resp.data.id}).`
              );
            } else {
              anexarMsgSistemaNoMotivo(`Crédito de Aula Experimental gerado.`);
            }
          }
        }

        // 1.2) Reagendada: registra se está usando crédito
        if (form.acao === 'Aula Experimental Reagendada') {
          try {
            const { data: cred } = await axios.get(
              `/operacional/prospeccao/${props.id}/credito-aula-experimental`
            );

            if (cred?.temCredito && cred?.credito?.id) {
              anexarMsgSistemaNoMotivo(
                `Reagendamento utilizando crédito de Aula Experimental (pagamento #${cred.credito.id}).`
              );
            } else {
              anexarMsgSistemaNoMotivo(
                `Reagendamento sem crédito disponível. Verificar financeiro antes de cobrar novamente.`
              );
            }
          } catch (e) {
            console.warn('[salvarInteracao] Falha ao consultar crédito no reagendamento:', e);
          }
        }

        // 1.3) Cancelada: registra que crédito permanece
        if (form.acao === 'Aula Experimental Cancelada') {
          try {
            const { data: cred } = await axios.get(
              `/operacional/prospeccao/${props.id}/credito-aula-experimental`
            );

            if (cred?.temCredito && cred?.credito?.id) {
              anexarMsgSistemaNoMotivo(
                `Aula cancelada. Crédito de Aula Experimental permanece disponível (pagamento #${cred.credito.id}).`
              );
            }

          } catch (e) {
            console.warn('[salvarInteracao] Falha ao consultar crédito no cancelamento:', e);
          }
        }

        // ==========================================================
        // 2) Atualiza prospecção
        // ==========================================================
        await axios.put(
          `/operacional/prospeccao/${props.id}/atualizar`,
          {
            usuario: proxy.$globalState.userName,
            classificacao: form.classificacao,
            data_acao: payloadBase.data_acao,
            data_proximo_contato: payloadBase.data_proximo_contato,
            acao: form.acao,
          }
        );

        // ==========================================================
        // 3) Salva histórico (com motivo já contendo msg do sistema)
        // ==========================================================
        const payloadHistorico = {
          ...payloadBase,
          motivo: form.motivo,
        };

        await axios.post(
          `/operacional/prospeccao/${props.id}/historico`,
          payloadHistorico
        );

        // ==========================================================
        // 6) Cancelar aula experimental
        // ==========================================================
        if (form.acao === 'Aula Experimental Cancelada') {
          await axios.delete(
            `/operacional/aulas-experimentais-agendadas/prospeccao/${props.id}`
          );
          await axios.delete(
            `/operacional/aulas-experimentais/prospeccao/${props.id}`
          );
        }

        // ==========================================================
        // 7) Consumir crédito quando a aula foi realizada (Presente)
        //    + registra um histórico só do consumo
        // ==========================================================
        if (form.classificacao === 'Aula experimental - confirmada' && form.acao === 'Presente') {
          try {
            const { data: r } = await axios.post(
              `/operacional/prospeccao/${props.id}/credito-aula-experimental/consumir`,
              { usuario: proxy.$globalState.userName }
            );

            if (r?.credito?.id) {
              await axios.post(
                `/operacional/prospeccao/${props.id}/historico`,
                {
                  prospeccao_id: props.id,
                  usuario: proxy.$globalState.userName,
                  acao: form.acao,
                  classificacao: form.classificacao,
                  data_acao: sanitizeDate(form.data_acao),
                  motivo: `[SISTEMA] Aula realizada. Crédito de Aula Experimental consumido (pagamento #${r.credito.id}).`,
                  data_aula_experimental: sanitizeDate(form.data_aula_experimental),
                  data_proximo_contato: sanitizeDate(form.data_proximo_contato),
                  nivel_nome: nivelStr,
                  turma_nome: turmaStr,
                }
              );
            }
          } catch (e) {
            console.warn('[salvarInteracao] Falha ao consumir crédito:', e);
          }
        }

        emit('salvou', payloadHistorico);
        cancel();
      } catch (err) {
        console.error('[salvarInteracao] Erro ao salvar interação:', err);
        alert(err.response?.data?.error || 'Não foi possível salvar a interação.');
      } finally {
        isSubmitting.value = false;
      }
    };

    const nivelNome = computed(() => {
      const nivelSelecionado = niveis.value.find(n => String(n.id) === String(form.nivel_id));
      return nivelSelecionado ? nivelSelecionado.nivel : '';
    });

    watch(
      () => form.data_pagamento,
      (novaData) => {
        if (!form.forma_pagamento_id || isAInformar(form.forma_pagamento_id)) {
          form.data_recebimento = '';
          return;
        }
        form.data_recebimento = novaData
          ? (globalUtils.calcularDataRecebimento(
              novaData,
              form.forma_pagamento_id,
              formasPagamento.value
            ) || '')
          : '';
      }
    );

    const cancel = () => {
      emit('fechar');
    };

    onMounted(async () => {

      await carregarFormasPagamento();
      await carregarContasFinanceiras();
      await carregarNiveis();
      await carregarTurmas();

      definirClassificacaoPadrao();
      atualizarAcoes();

      isLoading.value = false;
    });

    return {
      form,
      niveis,
      turmas,
      formasPagamento,
      contasFinanceiras,
      contasMensagem,
      reagendamentos,
      acoesOptions,
      atualizarAcoes,
      showRegra2,
      showRegra3,
      showRegra4,
      showRegra5,
      showRegra6,
      totalAPagar,
      isCheque,
      formValid,
      isAInformar,
      isEspecie,
      salvarInteracao,
      cancel,
      showMotivoExtraConfirmada,
      showMotivoExtraConfirmar,
      globalUtils,
      turmaNome,
      nivelNome,
      isLoading,
      isSubmitting,
      isCartao,
      showCobranca,
      showProximoContatoPresente,
      temCreditoAulaExperimental,
      creditoAulaExperimental,
      carregarCreditoAulaExperimental,
    };
  }
};
</script>

<style scoped>
/* Layout compartilhado com o primeiro modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-container {
  background: #fff;
  width: 100%;
  max-width: 50%;
  height: auto;
  min-height: auto;
  overflow-y: auto;
  margin: 0 10px;
  border-radius: 0px;
}

/* Cabeçalho do modal */
.modal-header {
  background: #ccc;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Conteúdo do modal */
.modal-content {
  padding: 25px;
}

.turma {
  /* background: #ccc; */
  padding: 5px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}


/* Espaço após o cabeçalho */
.spacer {
  margin-bottom: 20px;
}

/* Conteúdo do modal */
.modal-content {
  padding: 25px;
}

/* Seção e grupos de formulário */
.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 10px;
  margin-left: 0px;
  margin-right: 0px;

}

.form-group label {
  font-weight: bold;
  margin-bottom: 5px;
  display: block;
}

.required {
  color: red;
}

.form-control {
  width: 100%;
  padding: 5px;
  border: 1px solid #ced4da;
  border-radius: 0px;
}

/* Botões */
.btn {
  /* padding: 6px 12px; */
  border: none;
  cursor: pointer;
  margin-right: 25px;
  margin-top: 15%;
}

.btn-primary {
  background: #007bff;
  color: #fff;
}

.btn-secondary {
  background: #6c757d;
  color: #fff;
}

/* Outras classes utilitárias */
.d-flex {
  display: flex;
}

.justify-content-end {
  justify-content: flex-end;
}

.me-2 {
  margin-right: 0.5rem;
}

.mt-4 {
  margin-top: 1.5rem;
}

.mb-4 {
  margin-bottom: 1.5rem;
}

/* Outras classes utilizadas na estrutura */
.row {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.col {
  flex: 1;
  padding: 0 2px;
  min-width: 150px;
}

.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}
</style>
